var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      !_vm.target || _vm.target === "general"
        ? _c("FieldsetPropertyGeneralData", {
            attrs: { property: _vm.property, labelAlign: _vm.labelAlign }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.target ? _c("hr") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }